import React from 'react'
import {
  Button,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';

import data from './data'

const TRACKING_PARAM = '?emt=PD_proxtra';

export const ProDeskProXtraPods = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mt-10" data-component="ProDeskProXtraPods">
      <Typography variant="h2">Pro Xtra Loyalty Program</Typography>
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 lg:sui-grid-cols-4 sui-gap-4">
        {data.map(({ title, description, imageUrl, ctaUrl }) => (
          <Card key={`${title}`}>
            <CardMedia src={imageUrl} alt={title} aspect="wide" />
            <CardTitle header={title} />
            <CardBody>
              <Typography>{description}</Typography>
            </CardBody>
            <CardActions>
              <a
                href={`${ctaUrl}${TRACKING_PARAM}`}
                className="hover:sui-no-underline"
              >
                <Button fullWidth variant="text">
                  Explore More
                </Button>
              </a>
            </CardActions>
          </Card>
        ))}
      </div>
    </div>
  )
}

ProDeskProXtraPods.displayName = 'ProDeskProXtraPods'
